import React, { useEffect } from "react";
import { Flex } from "rebass";

import { SpinnerSVG } from "../../components/svg/SpinnerSVG";

import { useSignOut } from "../../hooks/useSignOut";

export const SignOutPage: React.FC = () => {
  const { isPending, signOut } = useSignOut();

  useEffect(() => {
    signOut();
  }, [signOut]);

  return (
    <Flex
      height="100%"
      justifyContent="center"
      alignItems="center"
      color="sp-blue"
    >
      {
        isPending
          ? <SpinnerSVG size={35} />
          : null
      }
    </Flex>
  );
};
